import React, { useState, useEffect } from "react";

const AssignModal = ({
  modelOpen,
  assignedTo,
  employees,
  setAssignedTo,
  handleAssign,
  handleCloseModal,
}) => {
  //console.log(assignedTo);
  const apiUrl = process.env.REACT_APP_URL;
  const Token = localStorage.getItem("_ux98c_v1");

  const [loadPercentage, setLoadPercentage] = useState("");
  const [loadData, setLoadData] = useState("");

  useEffect(() => {
    if(assignedTo){
      fetch(`${apiUrl}/lead/loadOnEmployee?empId=${assignedTo}`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log(data);
        // if (data && Array.isArray(data.data)) {
        setLoadPercentage(data?.data?.employee);
        setLoadData(data?.data);
        // }
      });
    }
    return(()=>{
      setLoadData("");
    })
  }, [assignedTo]);

  return (
    <div
      className={`modal bg-black-7 ${modelOpen ? "show" : ""}`}
      style={{ display: modelOpen ? "block" : "none" }}
      tabIndex="-1"
      role="dialog"
    >
      <div
        className="modal-dialog modal-dialog-centered modal-xl"
        role="document"
      >
        <div className="modal-content rounded-3">
          <div className="modal-header">
            <h5 className="modal-title">Assign</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={handleCloseModal}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body" style={{ width: "100%" }}>
            <div className="row row-sm-1">
              <div className="col-sm-4 form-group">
                <label className="form-label">Assign : </label>
                <select
                  name="assignedTo"
                  value={assignedTo}
                  className="form-control form-select select2"
                  onChange={(e) => setAssignedTo(e.target.value)}
                >
                  <option>Select</option>
                  {employees.map((data, index) => (
                    <option value={data.id} key={index}>
                      {data.firstName + " " + data.lastName}
                    </option>
                  ))}
                </select>
              </div>

              {assignedTo && (
                <>
                  <div className="col-sm-4 form-group">
                    <label className="form-label">Current Lead Load (%)</label>
                    <input
                      className="form-control"
                      value={loadData?.pendingPercentage ?? ""}
                      type="number"
                      disabled
                    />
                  </div>

                  <div className="col-sm-4 form-group">
                    <label className="form-label">Allowed Lead Limit (%)</label>
                    <input
                      className="form-control"
                      value={loadPercentage?.leadLoadPercentage ?? ""}
                      type="number"
                      disabled
                    />
                  </div>
                </>
              )}

              {loadData?.pendingPercentage && (
                <div className="col-lg-12">
                  {loadData?.pendingPercentage <=
                  loadPercentage?.leadLoadPercentage ? (
                    <div>
                      <button
                        className="btn ripple btn-primary"
                        type="button"
                        onClick={handleAssign}
                      >
                        Save
                      </button>
                    </div>
                  ) : (
                    <div className="text-danger">
                      Employee is already overloaded with{" "}
                      {loadData?.pendingPercentage}% pending leads.
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignModal;
